/** Compiled, same-origin routes. Publishing metadata never supplies executable URLs or layouts. */
export type NativePageRoute = {
  pageId: string;
  path: string;
  legacyDetail?: { parameter: string; segment: string };
};

export const nativePageRoutes: ReadonlyArray<NativePageRoute> = [
  { pageId: 'lpc-offer-health', path: '/commercial-ops/lpc-offer-health' },
  {
    pageId: 'tours-command-centre',
    path: '/tours/command-centre',
    legacyDetail: { parameter: 'nativeTour', segment: 'tour' },
  },
];

/** Remove only workspace routing state; dates, filters and app-owned parameters survive unchanged. */
export function nativePageParams(search: string): URLSearchParams {
  const params = new URLSearchParams(search);
  for (const key of [
    'view',
    'lens',
    'thread',
    'card',
    'library',
    'export',
    'dataset',
    'domain',
    'metric',
    'section',
    'create',
    'createSpace',
    'brief',
    'lensView',
    'nativeTour',
  ]) {
    params.delete(key);
  }
  return params;
}

/** Reopening an app's own top tab must not reset its data mode or filters. */
export function nativePageNavigationUrl(href: string, pathname: string, search: string, hash = ''): string {
  const route = nativePageRoutes.find(
    (page) => page.path === href && (pathname === page.path || pathname.startsWith(`${page.path}/`)),
  );
  if (!route) return href;
  const query = nativePageParams(search).toString();
  return `${href}${query ? `?${query}` : ''}${hash}`;
}
